import * as React from 'react';

import OrderDeadline from '@/components/elements/Text/OrderDeadline';
import useClock from '@/hooks/date/useClock';
import { Race } from '@/lib/apollo/types/gen/graphql';
import { raceSelector } from '@/selectors/race';

import { ReleaseStatus, Time, Wrapper } from './style';

interface TimeInfoProps {
  race: Race;
  isSalesSuspended: boolean;
}

const TimeInfo: React.FC<TimeInfoProps> = React.memo(
  ({ race, isSalesSuspended }) => {
    const currentTime = useClock();

    return (
      <Wrapper>
        <Time>
          発走時刻
          <time>{race.startTime.format('H:mm')}</time>
        </Time>
        <Time>
          締切時刻
          <time>{race.orderDeadline.format('H:mm')}</time>
        </Time>
        {!isSalesSuspended &&
          raceSelector(race).marginedOrderDeadline.diff(currentTime, 's') >
            0 && (
            <ReleaseStatus data-testid="release-status">
              <OrderDeadline
                orderDeadline={raceSelector(race).marginedOrderDeadline}
              />
            </ReleaseStatus>
          )}
      </Wrapper>
    );
  },
);

export default TimeInfo;
